"use client";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { COMPANY_INFO } from "@/lib/constants";


export default function ContactInfo() {
  return (
    <div className="flex flex-col sm:flex-row space-y-8 pt-8 lg:justify-start items-center sm:items-start sm:gap-16">
      {/* Office */}
      <div className="flex items-center lg:items-start text-center lg:text-left h-full space-x-4">
       
        <div className="space-y-1">
          <h3 className="text-h5 text-background">Office</h3>
          <div className="text-background/70 mb-2">
            <p>{COMPANY_INFO.address}, {COMPANY_INFO.area}</p>
            <p>{COMPANY_INFO.city}, {COMPANY_INFO.postcode}</p>
          </div>
          <Link target="_blank" href="https://share.google/rAzQ2E029OaEKMIix" className="flex items-center justify-center lg:justify-start text-background hover:text-background/80 underline transition-colors group">
            Get Directions 
            <ArrowUpRight className="w-4 h-4 ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>


      {/* Email */}
      <div className="flex items-center lg:items-start text-center lg:text-left h-full space-x-2">
    
        <div className="space-y-1">
          <h3 className="text-h5 text-background">Email</h3>
          <p className="text-background/70 mb-0">
            24-hour response guarantee
          </p>
          <Link 
            href={`mailto:${COMPANY_INFO.email}`}
            className="text-background hover:text-background/80 underline transition-colors"
          >
            {COMPANY_INFO.email}
          </Link>
        </div>
      </div>

      

      
 
    </div>
  );
}